import { render, staticRenderFns } from "./update-line-items-matter-name.vue?vue&type=template&id=2d006e24&scoped=true&"
import script from "./update-line-items-matter-name.vue?vue&type=script&lang=ts&"
export * from "./update-line-items-matter-name.vue?vue&type=script&lang=ts&"
import style0 from "./update-line-items-matter-name.vue?vue&type=style&index=0&id=2d006e24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d006e24",
  null
  
)

export default component.exports